module.exports = __webpack_public_path__ + "img/people-34.786f649f.png";